import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

interface TrueImpactToggleProps {
  onColor?: keyof typeof COLORS;
  offColor?: keyof typeof COLORS;
  enabled: boolean;
  disabled?: boolean;
  width?: string;
  height?: string;
  className?: string;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

const StyledDiv = styled.div<{
  enabled: boolean;
  disabled?: boolean;
  width: string;
  height: string;
  onColor: keyof typeof COLORS;
  offColor: keyof typeof COLORS;
}>`
  border-radius: ${SPACERS.medium};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  position: relative;
  transition: all 0.5s;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background-color: ${({ enabled, disabled, onColor, offColor }) =>
    enabled
      ? disabled
        ? COLORS.ctaPrimarySubdued
        : COLORS[onColor]
      : COLORS[offColor]};
  .inner-toggle {
    border-radius: ${SPACERS.medium};
    transition: all 0.5s;
    position: absolute;
    top: 0;
    ${({ enabled }) =>
      enabled ? 'left: 100%; transform: translate(-100%);' : 'left: 0;'}
    width: 15px;
    height: 100%;
    background-color: ${({ enabled }) =>
      enabled ? COLORS.grayLightest : COLORS.grayDark};
    border: 3px solid
      ${({ enabled, disabled }) =>
        enabled
          ? disabled
            ? COLORS.ctaPrimarySubdued
            : COLORS.ctaPrimary
          : COLORS.grayLight};
  }
`;

const TrueImpactToggle: React.FC<TrueImpactToggleProps> = ({
  enabled,
  disabled,
  onColor = 'ctaPrimary',
  offColor = 'grayLight',
  width = '35px',
  height = '15px',
  className,
  onClick,
}) => (
  <StyledDiv
    width={width}
    height={height}
    enabled={enabled}
    disabled={disabled}
    className={className}
    onColor={onColor}
    offColor={offColor}
    onClick={disabled ? undefined : onClick}
  >
    <div className="inner-toggle"></div>
  </StyledDiv>
);

export default TrueImpactToggle;
